import { render, staticRenderFns } from "./roleSetting.vue?vue&type=template&id=70c0b2df"
import script from "./roleSetting.vue?vue&type=script&lang=js"
export * from "./roleSetting.vue?vue&type=script&lang=js"
import style0 from "./roleSetting.vue?vue&type=style&index=0&id=70c0b2df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports